import { render, staticRenderFns } from "./jwRank.vue?vue&type=template&id=98df3d3e&scoped=true"
import script from "./jwRank.vue?vue&type=script&lang=js"
export * from "./jwRank.vue?vue&type=script&lang=js"
import style0 from "./jwRank.vue?vue&type=style&index=0&id=98df3d3e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98df3d3e",
  null
  
)

export default component.exports